<template>
  <div>
    <h2>Confirm</h2>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>
